import React, { useState, useEffect } from 'react';
import userimg from "../assets/img/edit-profile/user-img.svg";
import axios from 'axios';
import { API } from '../services/api';
import profileimg from "../assets/img/profile/profile-img.svg"

const ImageUploader = ({ type, proImg, onUploadComplete }) => {
  const [image, setImage] = useState(null);
  const [imageArr, setImageArr] = useState([]);
  const [eventImageArr, setEventImageArr] = useState('');
  const [preview, setPreview] = useState(userimg);
  const [dragActive, setDragActive] = useState(false);
  const [isImg, setIsimg] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(null);
  const inputId = `upload-${type}`;


  useEffect(() => {
    setImage(null);
    setImageArr([]);
    setPreview(userimg);
    setIsimg(false);
  }, [type]);

  useEffect(() => {
    return () => {
      if (preview && preview !== userimg) {
        URL.revokeObjectURL(preview);
      }
    };
  }, [preview]);

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);

    const file = e.dataTransfer.files[0];
    if (file && file.type.startsWith("image/")) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleChange = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith("image/")) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    }
  };
  useEffect(() => {
    if (image !== '') {
      handleUpload();
    }
  }, [image])
 

  const handleUpload = async () => {
    if (!image) return;
    setIsimg(false)
    const formData = new FormData();
    formData.append('file', image);

    try {
      setUploading(true);
      setUploadSuccess(null);
      const response = await axios.post(type === "event" ? `${process.env.REACT_APP_API_URL}uploadEventImage` : `${process.env.REACT_APP_API_URL}uploadProfileImage`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'x-access-token': localStorage.getItem('userToken'),
        },
      });
     if(type === "event"){
      if (response.status) {
        setIsimg(true);
        setEventImageArr(response.data.data);        
      }
     }
     else{
     if (response.data.status) {
        setIsimg(true);
        setImageArr(response.data.data);
      }
     }
      

      if (onUploadComplete) {
        onUploadComplete(response.data.data, type);
      }
      setUploadSuccess(true);
    } catch (error) {
      console.error('Upload failed:', error);
      setUploadSuccess(false);
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="w-100">
      <div
        className={` ${dragActive ? 'border-blue-500 bg-blue-50' : 'border-gray-300'
          }`}
        onDragEnter={handleDrag}
        onDragLeave={handleDrag}
        onDragOver={handleDrag}
        onDrop={handleDrop}
      >
        <input
          type="file"
          accept="image/*"
          id={inputId}
          hidden
          onChange={handleChange}
        />
        <label htmlFor={inputId} className="cursor-pointer block">

          
          <img
            src={type === "event" ?  isImg ? API.uploadFilePath + eventImageArr :  proImg !== undefined ? API.uploadFilePath + proImg : profileimg :
              isImg ? API.uploadFilePath + imageArr?.url :  proImg !== undefined ? API.uploadFilePath + proImg : profileimg
            }
            alt="Preview"
            className="img-up"
          />
          <p className="mt-2 text-gray-600 upload-style">
            <b>Click to upload</b> <span className="text-blue-600 underline">or drag and drop<br />JPEG(max 1080 X 1080px , 5Mp)  </span>
          </p>
        </label>
      </div>
    </div>
  );
};

export default ImageUploader;
